import { render, staticRenderFns } from "./PlanningRules.vue?vue&type=template&id=2e13e665"
import script from "./PlanningRules.vue?vue&type=script&lang=js"
export * from "./PlanningRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports